export const minCardsGenerate: number = 6;
export const maxCardsGenerate: number = 20;
export const maxCardsInPopup: number = 14;
export const totalCards: number = 301;
